/**
 * What a coordinator is called wherever the app shows or signs with them: the
 * Dnevnik, a thread, a check-in, ⟦koordinator⟧ in a mail. The name they set,
 * then the address they log in with, then the role word — a login that has not
 * set a name yet still reads as somebody, never as an empty string.
 */
export function coordinatorLabel(
  c: { name: string; email?: string | null } | null | undefined,
  fallback = 'koordinator',
): string {
  return c?.name.trim() || c?.email?.trim() || fallback;
}

/** Whether a login still has to say who it is before the app opens. */
export function needsName(c: { name: string }): boolean {
  return c.name.trim() === '';
}
